import React from "react";
import { createTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { getContrastText } from "../utils/commonUtilities";
import ContrastCheckedIcon from "../components/icons/ContrastCheckedIcon";
export const colors = {
    Primary: "#000",
    quote: '#8D868B',
    white: '#fff'
};
export const defaultTheme = () => {
    var _a, _b;
    const vendorConfig = useSelector((state) => state.vendor.vendorDetails);
    const primaryColor = (_a = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.PrimaryThemeColor) !== null && _a !== void 0 ? _a : '#000';
    return createTheme({
        palette: {
            primary: {
                main: primaryColor,
                contrastText: getContrastText(primaryColor),
            },
        },
        typography: {
            fontFamily: vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.FontStyle,
        },
        components: {
            MuiCheckbox: {
                styleOverrides: {
                    root: ({ theme }) => ({
                        padding: '4px',
                        marginLeft: '9px',
                        '&.Mui-disabled .contrast-checked-icon-box': {
                            fill: theme.palette.action.disabled,
                            stroke: theme.palette.action.disabled,
                        },
                        '&.Mui-disabled .contrast-checked-icon-tick': {
                            fill: theme.palette.background.paper,
                        },
                    }),
                },
                defaultProps: {
                    checkedIcon: React.createElement(ContrastCheckedIcon, { boxColor: primaryColor, checkColor: getContrastText(primaryColor) }),
                },
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        textTransform: 'capitalize',
                    },
                    containedPrimary: {
                        '&:hover': {
                            backgroundColor: (_b = vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.PrimaryThemeColor) !== null && _b !== void 0 ? _b : '#000',
                        },
                    },
                    text: {
                        '&:hover:not(.active):not(.selected):not(.Mui-selected)': {
                            backgroundColor: '#F5F6F8',
                        },
                    },
                    outlined: {
                        '&:hover:not(.active):not(.selected):not(.Mui-selected)': {
                            backgroundColor: '#F5F6F8',
                        },
                    },
                },
            },
        }
    });
};
